// JSON-LD is rendered inside <script type="application/ld+json"> via
// dangerouslySetInnerHTML. JSON.stringify alone does not stop a string value
// containing "</script>" (or "<!--") from closing the script element early, so
// a Magento-sourced field could inject markup. Escape the characters that are
// significant to the HTML parser (and the JS line terminators U+2028/U+2029)
// as \uXXXX: the result is still valid, equivalent JSON for any consumer.
// Do not run JSON through DOMPurify — it is not HTML.
const JSON_SCRIPT_ESCAPES = {
  "<": "\\u003c",
  ">": "\\u003e",
  "&": "\\u0026",
  "\u2028": "\\u2028",
  "\u2029": "\\u2029",
};

/**
 * Serialize a value for embedding in an inline <script> (JSON-LD).
 *
 * @param {*} data - JSON-serializable value
 * @param {number|string} [space] - forwarded to JSON.stringify
 * @returns {string}
 */
export function serializeJsonLd(data, space) {
  const json = JSON.stringify(data, null, space);
  if (json === undefined) return "";
  return json.replace(/[<>&\u2028\u2029]/g, (ch) => JSON_SCRIPT_ESCAPES[ch]);
}

export default serializeJsonLd;
